<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-12">
          <router-link class="btn btn-dark" :to="{ name: 'cxc-linea_credito' }">
            <i class="fa fa-arrow-left"></i>
            Regresar
          </router-link>
          <br><br>
          <div class="element-box">
            <h5 class="form-header" style="text-align: center;">
              Línea de Crédito
              <br>
              <div class="badge" :class="{
                'badge-success': current.estatus == true,
                'badge-danger': current.estatus == false,
              }">
                <i class="os-icon os-icon-ui-09"></i>
                <span v-if="current.estatus == true"> Activo</span>
                <span v-if="current.estatus == false"> Inactivo</span>
              </div>
            </h5>
            <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{ current.errors.detail
              }}</small>
          </div>
        </div>
        <div class="col-3">
          <div class="element-box" style="padding: 1rem 0.5rem">
            <div class="col-12">
              <!-- <h6 
                  style = "
                  font-family: Rockwell Extra Bold;
                  font-size: 23px;
                  font-weight: bold;"
                  class="text-center text-success"> -->
              <h6 class="text-center text-success" style="font-size:23px;">
                Datos de Crédito
              </h6>
              <hr />
              <div class="form-group">
                <!-- <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 15px;
                    font-weight: bold;
                  " class="text-center"> -->
                <h6 class="text-center">
                  Número:
                </h6>
                <!-- <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 20px;
                    font-weight: bold;
                    color: #0033e1;
                  " class="text-center font-weight-bold"> -->
                <h6 class="text-center text-info" style="color: #0033e1">
                  {{ current.id }}
                </h6>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <!-- <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 15px;
                    font-weight: bold;
                  " class="text-center"> -->
                <h6 class="text-center">
                  Usuario:
                </h6>
                <!-- <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 15px;
                    font-weight: bold;
                    color: #0033e1;
                  " class="text-center"> -->
                <h6 class="text-center text-info" style="color:#0033e1">
                  {{ current.usuario }}
                </h6>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <!-- <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 15px;
                    font-weight: bold;
                  " class="text-center"> -->
                <h6 class="text-center" >
                  Fecha Creación:
                </h6>
                <!-- <h6 class="text-center" style="
                    font-family: Rockwell Extra Bold;
                    font-size: 15px;
                    font-weight: bold;
                    color: #0033e1;
                  "> -->
                <h6 class="text-center text-info">
                  {{ current.fecha_creacion }}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="element-box" style="padding: 1rem 0.5rem">
            <!-- <h6 style="
                font-family: Rockwell Extra Bold;
                font-size: 20px;
                font-weight: bold;
              " class="text-success"> -->
            <h6 class="text-success text-center" style="font-size:20px;">
              Detalle de Saldo
            </h6>
            <div class="table-responsive" v-if="current.id != null">
              <table class="table">
                <thead>
                  <tr>
                    <th class="text-left">Fecha</th>
                    <th class="text-left">Usuario que ingreso</th>
                    <th class="text-center">Valor</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead> 
                <tbody>
                  <tr v-for="detalle in current.lineacreditodetalle_set" v-bind:key="detalle.id">
                    <td>
                      <timeago :title="detalle.fecha_creacion" :datetime="detalle.fecha_creacion"></timeago>
                    </td>
                    <td>
                      {{ detalle.usuario.name }}
                    </td>
                    <td class="text-center">
                      Q {{ detalle.valor }} 
                    </td>
                    <td class="text-center"> {{ current.fecha }}
                      <button class="btn btn-danger" @click="eliminarDetalleSaldo(fechaFormateada(detalle.fecha_creacion), detalle.id)" 
                        v-if="fechaFormateada(detalle.fecha_creacion) === fechaActual()">
                        <i class="fa fa-trash fa-sm"></i>
                      </button>
                    </td>
                  </tr> 
                </tbody>
              </table>
              <div class>
                <button type="button" class="btn btn-sm btn-secondary btn-block" @click="showModalAddDetail"
                  v-if="current.estatus == true">
                  Agregar Saldo &nbsp;<i class="fa fa-plus"></i>
                </button>
              </div>
              <!-------------------- END - Basic Table -------------------->
            </div>
            <div class="form-buttons-w">
              <button class="btn btn-md btn-success" v-if="current.estado == 'A'" @click="guardar(current)">
                Guardar &nbsp;<i class="fas fa-save"></i>
              </button>
              <button @click="reiniciarSaldo()" class="btn btn-md btn-success btn-outline btn-block">
                Reiniciar Saldo &nbsp;<i class="fas fa-undo"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="element-box" style="padding: 1rem 0.5rem">
            <div class="col-12">            
              <h3 class="text-center text-success">
                Complementarios
              </h3>
              <hr />
            </div>
            <div class="col-12">
              <div class="form-group">
                <div v-if="current.tipo == 'LC'">
                  <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 18px;
                    font-weight: bold;
                  " class="text-center">
                    Limite de Crédito
                  </h6>
                  <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 35px;
                    color: #0033e1;
                    font-weight: bold;
                  " class="text-center">
                    Q {{ current.limite }}
                  </h6>
                </div>          
                <h6 class="text-center" style="font-size: 18px">
                  Saldo Disponible:
                </h6>           
                <h6 class="text-center text-success" style="font-size: 45px">
                  Q{{ current.saldo }}
                </h6>         
                <h6 class="text-center">
                  Estado:
                </h6>
                <h6 style="
                    font-family: Rockwell Extra Bold;
                    font-size: 35px;
                    color: #0033e1;
                    font-weight: bold;
                  " class="text-center">          
                  <button style="width:200px; font-weight:bold" 
                    type="button" class="text-center btn btn-success" @click="cambiarEstatus(current)"
                    v-if="current.estatus == true">
                    ACTIVO
                  </button>  
                  <button style="width:200px; font-weight:bold" 
                      type="button" @click="cambiarEstatus(current)" class="text-center btn btn-danger"
                      v-if="current.estatus == false">
                    INACTIVO
                  </button>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" class="modal fade" id="modalAddDetail" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div style="background-color: yellowgreen" class="modal-header faded smaller">
            <h5 class="modal-title">Elegir cargo para aplicar saldo</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <CargoTableComponent @cerrarModalDetail="cerrarModalDetail" @refreshCurrent="refreshCurrent"
                :current="current" />
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import CargoTableComponent from "@/components/cxc/linea_credito/CargoTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import LineaCreditoService from "@/services/cxc/LineaCreditoService";

export default {
  components: {
    CargoTableComponent,
    PaginationComponent,
  },
  data() {
    return {
      data: null,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      searchtext: "",
      filtro_tienda: "",
      cargos: null,
      current: {
        id: null,
        errors: [],
      },

      currentDetalle: {
        saldo: 0,
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent(this.$route.params.id);
    }
  },
  methods: {
    reiniciarSaldo() {
      let self = this;
      Notifications.alert.confirm(
        "Reiniciar Saldo",
        "¿Esta Seguro?",
        "",
        function () {
          DynamicService.postAction(
            "cxc",
            "linea-credito",
            self.current.id,
            "reiniciar_saldo"
          ).then((response) => {
            Notifications.alert.success(
              "Reiniciar saldo de credito",
              "Realizado Exitosamente"
            );
            self.refreshCurrent();
          });
        }
      );
    },
    cambiarEstatus(current) {
      let self = this;
      if (current.estatus == true) {
        current.estatus = false;
      } else {
        current.estatus = true;
      }
      LineaCreditoService.update("cxc", "linea-credito", current)
        .then((response) => {
          self.refreshCurrent();
        })
        .catch((error) => {
          Notifications.alert.error(
            "Crear Nueva Linea de Credito",
            error.response.data.detail
          );
        });
    },
    customFormatter(date) {
      this.current.fecha_creacion = moment(date).format("DD-MM-YYYY");
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "cxc",
        "linea-credito",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;        
        self.current.usuario = response.data.usuario.name;
        self.customFormatter(self.current.fecha_creacion);        
      });
    },
    cerrarModalDetail() {
      $("#modalAddDetail").modal("hide");
    },
    showModalAddDetail() {
      let self = this;

      /**Se agrega Notificacion al usuario que la linea de 
       * credito ya posee saldo, si desea agregar mas saldo
       */
      if(self.current.saldo > 0) {
        Notifications.alert.confirm(
          "Esta linea de crédito ya posee saldo ",
          "¿Desea agregar más saldo?",
          "Sí",
          function(){
            $("#modalAddDetail").modal();
          }          
        )
      }
      else{
        $("#modalAddDetail").modal();
      }

      
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        saldo: 0,
        unidad_medida: null,
        errors: [],
      };
    },
    eliminarDetalleSaldo(fecha_creacion, id_detalle){
      let self=this;
   
      if(self.fechaActual() !== fecha_creacion){
        Notifications.alert.error("Eliminar detalle de saldo", "Solo se puede eliminar detalle saldo de día actual ")
        return;
      }

      let params = { }      

      Notifications.alert.confirm(
        "Eliminar Saldo",
        "¿Esta seguro que desea eliminar el saldo?",
        "",        
        function(){
          DynamicService.postAction(
            "cxc",
            "linea-credito",
            id_detalle,
            "eliminar_detalle_saldo",
            params
          ).then((response) =>{            
            self.refreshCurrent();
            Notifications.alert.success("Saldo ha sido eliminado", "Se ha eliminado el saldo correctamente")
          }).catch((error) =>{
            Notifications.alert.error("Saldo no ha podido ser eliminado", error.response.data.detail)
          })
        }
      )
    },
    fechaActual(){
      return moment().format("DD-MM-YYYY")
    },
    fechaFormateada(fecha){
      return moment(fecha).format("DD-MM-YYYY")

    }



    // imprimir() {
    //   let self = this;
    //   AjusteInventarioService.pdf(self.current.id)
    //     .then((response) => {
    //       console.log(response.data.output);
    //       window.open(response.data.output);
    //     })
    //     .catch((error) => {
    //       Notifications.alert.error(
    //         "No se ha podido realizar la acción",
    //         error.response.data.detail
    //       );
    //     });
    // },
  },
};
</script>
